// extracted by mini-css-extract-plugin
export default {"scrollButton":"ScrollToTopBtn_scrollButton__6IPdB"};